import { useMemo } from 'react';

import { useRoute } from 'hooks/navigation/use-route';
import { IAuthRouteParams, ModalAuthScreen } from 'state/auth/types';
import { routes } from 'utils/routing';
import { stringToBool } from 'utils/string-To-Bool';

import { useAuthContext } from '..';

type IUseAuthFlow = () => {
  isInAuthFlow: boolean;
  activeRouteIsSignIn: boolean;
  showOtpForm: boolean;
  hasSignedOut: boolean;
  errorMessage: string | undefined;
  triggerSignInAccessibility: boolean;
};

const useAuthFlow: IUseAuthFlow = () => {
  const { params, pathname } = useRoute<IAuthRouteParams>();
  const { modalAuthState } = useAuthContext();

  // @ts-ignore
  const staticPageParams: { staticPagePath?: string } = params?.params || params || {};

  const isModalStaticPageRoute =
    pathname.startsWith(routes.staticPage) ||
    pathname.startsWith(routes.modalStaticPage) ||
    !!staticPageParams.staticPagePath;

  const isSignUp = modalAuthState.screen === ModalAuthScreen.SIGN_UP;
  const isSignIn = modalAuthState.screen === ModalAuthScreen.SIGN_IN;

  const showOtpForm =
    pathname === routes.confirmOtp ||
    stringToBool(params?.showOtpForm) ||
    modalAuthState.screen === ModalAuthScreen.OTP;

  const hasSignedOut = stringToBool(params?.hasSignedOut);
  const errorMessage = params?.errorMessage;
  const triggerSignInAccessibility = stringToBool(params?.triggerSignInAccessibility);

  return useMemo(
    () => ({
      isInAuthFlow: isSignUp || isSignIn || showOtpForm || isModalStaticPageRoute,
      activeRouteIsSignIn: isSignIn,
      showOtpForm,
      hasSignedOut,
      errorMessage,
      triggerSignInAccessibility,
    }),
    [
      isSignUp,
      isSignIn,
      isModalStaticPageRoute,
      showOtpForm,
      hasSignedOut,
      errorMessage,
      triggerSignInAccessibility,
    ]
  );
};

export default useAuthFlow;
